"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
let FarmItem = class FarmItem extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get triggers() {
        if (this.tooltipEnabled)
            return 'hover';
        return '';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FarmItem.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], FarmItem.prototype, "tooltipEnabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], FarmItem.prototype, "scoreEnabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], FarmItem.prototype, "theme", void 0);
FarmItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MetricRankTag: MetricRankTag_vue_1.default
        },
    })
], FarmItem);
exports.default = FarmItem;
